import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const fmt = (n, dec=2) => Number(n ?? 0).toLocaleString("tr-TR", { minimumFractionDigits: dec, maximumFractionDigits: dec });

function Row({ item }) {
  const dir = item.dir?.satis_dir || "";
  const color = dir === "up" ? "text-emerald-400" : dir === "down" ? "text-red-400" : "text-white";
  const arrow = dir === "up" ? "▲" : dir === "down" ? "▼" : "";
  const unit = item.unit || "₺";
  return (
    <div className="flex justify-between items-baseline gap-3 py-3 sm:py-4 border-b border-white/5" data-testid={`karat-${item.code}`}>
      <div className="min-w-0 flex-1">
        <div className="text-sm truncate">{item.label}</div>
        <div className="label-caps mt-1 truncate">{item.code}</div>
      </div>
      <div className="text-right shrink-0">
        <div className={`font-mono tabular-nums text-base sm:text-lg ${color}`}>
          {arrow} {fmt(item.selling, item.selling > 100 ? 2 : 4)} <span className="text-xs sm:text-sm">{unit}</span>
        </div>
        <div className="font-mono text-[10px] sm:text-xs text-neutral-500 tabular-nums mt-1">
          Alış {fmt(item.buying, item.buying > 100 ? 2 : 4)} {unit}
        </div>
      </div>
    </div>
  );
}

export default function Karats() {
  const [karats, setKarats] = useState({});
  const [fx, setFx] = useState({});
  const [updated, setUpdated] = useState("");

  useEffect(() => {
    const load = async () => {
      const [k, f] = await Promise.all([api.get("/karats"), api.get("/fx")]);
      setKarats(k.data.karats || {});
      setFx(f.data.pairs || {});
      setUpdated(k.data.last_updated || "");
    };
    load();
    const iv = setInterval(load, 3000);
    return () => clearInterval(iv);
  }, []);

  const karatOrder = ["ONS","ALTIN","AYAR22","AYAR14","KULCEALTIN","CEYREK_YENI","YARIM_YENI","TAM_YENI","ATA_YENI","GREMESE_YENI","BESLIYENI","CUMHURIYET","GUMUSTRY","XAGUSD","XPTUSD","PLATIN","PLATIN_GRAM_TL","XPDUSD","PALADYUM"];
  const karatItems = karatOrder.map(c => karats[c]).filter(Boolean);

  return (
    <div className="space-y-8" data-testid="karats-page">
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-2">
        <div className="min-w-0">
          <div className="label-caps">Canlı Fiyat Panosu · Harem Altın</div>
          <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl mt-2 font-light">Ayar & Ziynet</h1>
        </div>
        <div className="text-xs text-neutral-500 shrink-0">
          Güncelleme: <span className="font-mono">{updated ? new Date(updated).toLocaleTimeString("tr-TR") : "—"}</span>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 lg:gap-6">
        <div className="card-flat p-4 sm:p-6">
          <div className="label-caps mb-1">Altın Türleri</div>
          <div className="font-display text-xl sm:text-2xl mb-4">Gram & Ziynet</div>
          {karatItems.length === 0 && <div className="text-neutral-500 text-sm py-6">Canlı veri bekleniyor…</div>}
          {karatItems.map(k => <Row key={k.code} item={k} />)}
        </div>

        <div className="card-flat p-4 sm:p-6">
          <div className="label-caps mb-1">Döviz Paneli</div>
          <div className="font-display text-xl sm:text-2xl mb-4">Kambiyo</div>
          {Object.keys(fx).length === 0 && <div className="text-neutral-500 text-sm py-6">Canlı veri bekleniyor…</div>}
          {Object.values(fx).map(k => <Row key={k.code} item={k} />)}
        </div>
      </div>
    </div>
  );
}
